module.exports = __webpack_public_path__ + "img/help_img1.92793d30.svg";